
import { Component, computed, EventEmitter, Input, OnInit, Output, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MiscUtil } from '../../../util/misc.util';

 
import { DynformControl } from '../../../model/dymform-control';

import { inject } from '@angular/core';

import { LibModulesWolcModule } from '../../../components/lib-modules-wolc.module';
import { BooktechAppService } from "../../../services/booktech-app.service";
import { BtSelectGuestsComponent } from '../select-guests/select-guests.component';
import { BtEvent } from '../../../services/event.service';


@Component({
    selector: 'btlib-pw-period-guests',
    imports: [LibModulesWolcModule, BtSelectGuestsComponent],
    templateUrl: './pw-period-guests.component.html',
    styleUrl: './pw-period-guests.component.scss'
})
export class BtPwPeriodGuestsComponent {
  bas = inject(BooktechAppService);


  route = inject(ActivatedRoute);

  views:any = {
    default: {
      grid: {
        date:     { xs: 24, sm: 24, md: 24, lg: 24, xl: 24,  xxl: 24,  gutter: 16 },
        guests:   { xs: 24, sm: 24, md: 24, lg: 24, xl: 24,  xxl: 24,  gutter: 16 },
      },
      size: "default"
    },
    fullWidth: {
      grid: {
        date:     { xs: 24, sm: 16, md: 14, lg: 10, xl: 12,  xxl: 9,  gutter: 16 },
        guests:   { xs: 24, sm: 8, md: 10, lg: 7, xl: 6,  xxl: 5,  gutter: 16 },
      },
      size: "large"
    }
  };
  view = this.views.default;

  
  _pwSignal = signal<any>(null);
  timegridVersion = signal(0);

  // Caches to keep stable array references for Mobiscroll [valid] input
  private _validStartCache: { key: string; value: any[] } | undefined;
  private _validEndCache: { key: string; value: any[] } | undefined;

  // Signature of the last pw used to build the timegrid, to avoid resetting state
  // when the server returns a new object reference with the same data.
  private _lastTimegridPwSignature: string | undefined;

  get _pw(): any { return this._pwSignal(); }
  set _pw(pw: any) { this._pwSignal.set(pw); }

  @Input()
  get pw(): any { return this._pw; }
  set pw(pw: any) {
    if (!pw) return;

    const oldPw = this._pw;

    // Avoid no-op updates and circular updates (e.g. PwUpdate already set the same reference)
    if (pw === oldPw) return;

    if(this.bas.envtest) console.log("BtPwPeriodGuestsComponent, SETTING _pw: ", pw);

    // pw is now the new source of truth from OrderService (immutable copy)
    this._pw = pw;

    if (pw.productObj?.useTimegrid) {
      this.updateTimeGrid(pw);
    }
  }

  validStart = computed(() => {
    const pw = this._pwSignal();
    this.timegridVersion(); // subscribe to timegrid state changes
    const tg = this.timegrid;
    let validStart: any[] = [];
    if (pw?.productObj?.useTimegrid) {
      const timeItem = pw.timeItemsAvailable?.[0];
      if (timeItem?.items?.length) {
        const items = timeItem.items;
        const minDuration = tg.minDurationMinutes || 0;
        const latestEndTime = minDuration > 0 ? this.getLatestValidEndTime(items) : null;
        const startTime = this.bas.ui.timeFormat(tg.start);
        ({ validStart } = this.buildValidRanges(items, startTime, minDuration, latestEndTime));
      }
    }
    return this._getCachedValidStart(validStart);
  });

  validEnd = computed(() => {
    const pw = this._pwSignal();
    this.timegridVersion(); // subscribe to timegrid state changes
    const tg = this.timegrid;
    let validEnd: any[] = [];
    if (pw?.productObj?.useTimegrid) {
      const timeItem = pw.timeItemsAvailable?.[0];
      if (timeItem?.items?.length) {
        const items = timeItem.items;
        const minDuration = tg.minDurationMinutes || 0;
        const latestEndTime = minDuration > 0 ? this.getLatestValidEndTime(items) : null;
        const startTime = this.bas.ui.timeFormat(tg.start);
        ({ validEnd } = this.buildValidRanges(items, startTime, minDuration, latestEndTime));
      }
    }
    return this._getCachedValidEnd(validEnd);
  });

  private _getCachedValidStart(validStart: any[]): any[] {
    const key = JSON.stringify(validStart);
    if (this._validStartCache && this._validStartCache.key === key) {
      return this._validStartCache.value;
    }
    this._validStartCache = { key, value: validStart };
    return validStart;
  }

  private _getCachedValidEnd(validEnd: any[]): any[] {
    const key = JSON.stringify(validEnd);
    if (this._validEndCache && this._validEndCache.key === key) {
      return this._validEndCache.value;
    }
    this._validEndCache = { key, value: validEnd };
    return validEnd;
  }

  private _getTimegridPwSignature(pw: any): string {
    if (!pw) return '';
    const tiSig = (pw.timeItemsAvailable || []).map((ti: any) => {
      const itemsSig = (ti.items || []).map((item: any) => {
        return `${item.startTimeAsString || item.startAsString || ''}-${item.endTimeAsString || item.endAsString || ''}:${item.available ?? ''}`;
      }).join('|');
      return `${ti.startTimeAsString || ''}|${ti.endTimeAsString || ''}|${ti.duration || 0}|${ti.minDurationMinutes || 0}|${itemsSig}`;
    }).join('||');
    return `${pw.startAsIso8601 || ''}|${pw.endAsIso8601 || ''}|${tiSig}`;
  }

  @Input() opts:any = { };
  @Output() change = new EventEmitter<any>();

  options:any = {
    time: {

    },
    date: {

    },
    misc: {

    }
  }

  // rangeOptions:any = {
  //   inRangeInvalid: false
  // }
  
  
  dateInvalid:any[] = [];
  dateColors:any[] = [];

  pwInput:any = undefined;

  timegrid:any = {
    visible: false,
    collapseStart: true,
    collapseEnd: this.bas.ui.r.gtesm,
    label: 'app.cbapi5.common.selectTime',
    validStart: [
      // { start: '12:00', end: '13:59', recurring: { repeat: 'daily' } } // Trekke fra ett minutt på end
    ],
    validEnd: [
      // { start: '12:01', end: '14:00', recurring: { repeat: 'daily' } } // Legge til ett minutt på start

    ],
    minDurationMinutes: 0,

  }

  data:any = {

  }

  constructor() {
    // this.route = inject(ActivatedRoute);
    // this.bas.us.checkActivatedRoute(this.route.snapshot);

    // let qps = this.route.snapshot.queryParams; //periodAsRange
    // if(this.bas.envtest) console.log("BtPwPeriodGuestsComponent, qps: ", qps);



  }

  isFullWidth() {
    return this.view == this.views.fullWidth;
  }

  ngOnInit(): void {
    let opts = this.opts;
    if (opts.viewName) {
      this.view = this.views[opts.viewName];
    }

    if(this.bas.envtest) console.log("BtPwPeriodGuestsComponent, opts: ", opts);
    if(this.bas.envtest) console.log("BtPwPeriodGuestsComponent, pw: ", this.pw);
    // this.postChange();

    if (this.bas.ds.findCid('pw-period-guests.ngOnInit') === "skaperverkettonsberg") { //TODO
      this.options.date = {
        inRangeInvalid: true,
        // rangeEndInvalid: false
      }
      
    }



    let pw = this._pw; 
    // let pwid = pw.id;
    this.updateTimeGrid(pw);

    this.bas.es.on(BtEvent.LibPwUpdate, (ev:any) => {
      if (this.pw.productId != ev.pw.productId) return;  // Må vi sjekke på andre ting også?
 

      pw = this._pw; 
      if(this.bas.envtest) console.log("AppPwPeriodGuestsComponent, PwUpdate, startDateAsJsDate: " + pw.startDateAsJsDate + " -> " + ev.pw.startDateAsJsDate +", ev: ", ev);
      
      // Skip if this component already has the same pw object (reactive setter handled it)
      if (ev.pw === this._pw) return;

      this.data.isRunning = true;

      this._pw = ev.pw;

      // if (this._pw.id == ev.id) {
        if (pw.startDate != ev.pw.startDate) {
          // if(this.bas.envtest) console.log("AppPwPeriodGuestsComponent, PwUpdate, startDate has changed: "+this._pw.startDate + " -> " + ev.pw.startDate + ", pw.productObj.useTimegrid: " + ev.pw.productObj.useTimegrid  +" ev: ", ev);
          // this._pw;
          this.updateTimeGrid(ev.pw);
        } else {
          this.timegridVisibleChange(true);
        }
      // }

      this.data.isRunning = false;
      if(this.bas.envtest) console.log("AppPwPeriodGuestsComponent, PwUpdate.after, startDateAsJsDate: " + this._pw.startDateAsJsDate)
   
    })




    // let tg = this.timegrid;
    // if (tg.startTimeAsString == undefined) {
    //   tg.star = item.startTimeAsString;
    //   tg.end = item.endTimeAsString;
    //   tg.label = tg.startTimeAsString + " - " + tg.endTimeAsString;

      
    // }

  }


  // ===== TimeGrid Helper Methods =====

  private getLatestValidEndTime(items: any[]): Date | null {
    for (let i = items.length - 1; i >= 0; i--) {
      const item = items[i];
      if (item.available > 0 || (i > 0 && items[i-1].available > 0)) {
        return this.bas.ui.dateParse(item.endAsString);
      }
    }
    return items.length ? this.bas.ui.dateParse(items[items.length - 1].endAsString) : null;
  }

  private canStartTimeFulfillMinDuration(
    itemStartStr: string,
    minDurationMinutes: number,
    latestEndTime: Date | null,
    items: any[],
    startIdx: number
  ): boolean {
    if (!minDurationMinutes) return true;

    const itemStart = this.bas.ui.dateParse(itemStartStr);
    const minEnd = this.bas.ui.dateAdd(itemStart, { minutes: minDurationMinutes });

    // Find the end of the current available block (next unavailable or end of day)
    let blockEndTime = latestEndTime;
    for (let i = startIdx; i < items.length; i++) {
      const current = items[i];
      const next = items[i + 1];

      // If current is last item or next is unavailable/not contiguous, this is the block end
      if (!next || next.available <= 0 || next.startAsString !== current.endAsString) {
        blockEndTime = this.bas.ui.dateParse(current.endAsString);
        break;
      }
    }

    return !blockEndTime || minEnd.getTime() <= blockEndTime.getTime();
  }

  private calculateMinEndTimeStr(startTime: string | undefined, minDurationMinutes: number): string | undefined {
    if (!minDurationMinutes || !startTime) return undefined;
    const minEnd = this.bas.ui.dateAdd(
      this.bas.ui.timeParse(startTime),
      { minutes: minDurationMinutes }
    );
    return this.bas.ui.timeFormat(minEnd);
  }

  private buildValidRanges(
    items: any[],
    startTime: string | undefined,
    minDuration: number,
    latestEndTime: Date | null
  ): { validStart: any[], validEnd: any[], lastEndItem: any | undefined } {
    const validStart: any[] = [];
    const validEnd: any[] = [];
    let lastEndItem: any | undefined = undefined;
    let notAvailable = false;
    let startItem: any = false;
    let prev: any = false;

    const minEndTimeStr = this.calculateMinEndTimeStr(startTime, minDuration);

    for (let idx = 0; idx < items.length; idx++) {
      const item = items[idx];
      const prevItem = items[idx - 1];
      const nextItem = items[idx + 1];

      if (!startItem && item.startTimeAsString === startTime) {
        startItem = item;
      }

      const slotStart = this.bas.ui.dateParse(item.startAsString);
      const slotStartStr = this.bas.ui.timeFormat(slotStart) || '';
      item.startAsDate = slotStart;

      const adjustedEnd = this.bas.ui.dateAdd(
        this.bas.ui.dateParse(item.endAsString),
        { minutes: -1 }
      );
      const adjustedEndStr = this.bas.ui.timeFormat(adjustedEnd);
      item.endAsDate = this.bas.ui.dateParse(item.endAsString);

      const isFirst = item.startAsString === items[0].startAsString ||
        (prevItem && prevItem.endAsString !== item.startAsString);
      const isLast = item.endAsString === items[items.length - 1].endAsString ||
        (!nextItem || nextItem.startAsString !== item.endAsString);

      item.isFirst = isFirst;
      item.isLast = isLast;
      item.endTimeAfterStart = !startTime || item.startTimeAsString > startTime;

      if (isFirst && idx > 0 && startTime && startTime < item.startTimeAsString) {
        notAvailable = true;
      }

      const isAvailable = item.available > 0;

      if (isAvailable) {
        // Build validStart
        const canBeStart = this.canStartTimeFulfillMinDuration(
          item.startAsString,
          minDuration,
          latestEndTime,
          items,
          idx
        );

        if (canBeStart) {
          validStart.push({
            start: item.startTimeAsString,
            end: adjustedEndStr,
            recurring: { repeat: 'daily' }
          });
          item.validStart = true;
        } else {
          item.validStart = false;
        }

        // Build validEnd
        if (!notAvailable && startTime && (item.startTimeAsString > startTime || isLast)) {
          if (item.startTimeAsString > startTime) {
            const isTooEarly = minEndTimeStr && slotStartStr < minEndTimeStr;
            if (!isTooEarly) {
              validEnd.push({
                start: slotStartStr,
                end: adjustedEndStr,
                recurring: { repeat: 'daily' }
              });
              item.validEnd = true;
            } else {
              item.validEnd = false;
            }
          }

          if (isLast && item.startTimeAsString > startTime) {
            validEnd.push({
              start: item.endAsString,
              end: item.endAsString,
              recurring: { repeat: 'daily' }
            });
            lastEndItem = MiscUtil.clone(item);
            lastEndItem.startTimeAsString = item.endTimeAsString;
          }
        }
      } else {
        if (startItem) notAvailable = true;

        // Handle case where previous slot was available but current is not
        if (prev && prev.available > 0 && startTime && item.startTimeAsString > startTime) {
          validEnd.push({
            start: slotStartStr,
            end: adjustedEndStr,
            recurring: { repeat: 'daily' }
          });
          item.validEnd = true;
        }
      }

      prev = item;
    }

    return { validStart, validEnd, lastEndItem };
  }

  timegridVisibleChange(event:any) {
    if(this.bas.envtest) console.log("BtPwPeriodGuestsComponent, timegridVisibleChange, Visible: " + event);

    const pw = this.pw;
    const tg = this.timegrid;

    if (!pw.productObj.useTimegrid) return;
    if (!event) return;

    tg.lastEndItem = undefined;

    let startTime = this.bas.ui.timeFormat(tg.start);
    let endTime = this.bas.ui.timeFormat(tg.end);

    const timeItem = pw.timeItemsAvailable && pw.timeItemsAvailable[0];
    if (!timeItem?.items?.length) { return; }
    if (!timeItem) return;

    const items = timeItem.items || [];
    const minDuration = tg.minDurationMinutes || 0;

    // Clamp times to available range
    if (items.length) {
      const firstItem = items[0];
      const lastItem = items[items.length - 1];

      if (endTime && endTime > lastItem.endTimeAsString) {
        endTime = lastItem.endTimeAsString;
        tg.end = this.bas.ui.timeParse(tg.endTime, undefined, tg.end);
      }

      if (startTime && (startTime < firstItem.startTimeAsString || (endTime && startTime > endTime))) {
        startTime = firstItem.startTimeAsString;
        tg.start = this.bas.ui.timeParse(tg.startTime, undefined, tg.start);
      }

      tg.label = startTime + " - " + endTime;
    }

    // Build valid ranges for lastEndItem only — validStart/validEnd are computed signals
    const latestEndTime = minDuration > 0 ? this.getLatestValidEndTime(items) : null;
    const { lastEndItem } = this.buildValidRanges(
      items,
      startTime,
      minDuration,
      latestEndTime
    );

    tg.items = [...items];
    tg.lastEndItem = lastEndItem;

    // Bump signal to trigger recomputation of validStart/validEnd
    this.timegridVersion.update(v => v + 1);

    if(this.bas.envtest) console.log("BtPwPeriodGuestsComponent, timegridVisibleChange, tg: ", tg);
  }

  showTimegrid() {
    let tg = this.timegrid;
    tg.visible = true;

    if (this.bas.ui.r.ltsm) {
      tg.collapseStart = true;
      tg.collapseEnd = false;
    }

    this.timegridVisibleChange(true);
  }

  onTimegridChange(field:'start'|'end', event:any)  {
   
    let isStart = field == "start";

    let pw = this.pw;
    let ti = pw.timeItemsAvailable && pw.timeItemsAvailable[0];
    let tg = this.timegrid;

    if (!pw.productObj.useTimegrid) return; 

    if(this.bas.envtest) console.log("onTimegridChange"
      + ", field: "+field
      + ", tg.start: "+tg.start
      + ", tg.end: "+tg.end
      + ", tg.startTime: "+tg.startTime
      + ", tg.endTime: "+tg.endTime
      +", event: " + (event?.valueText || event) 
      + ", tg: ", this.timegrid);

    if (isStart && event?.valueText === undefined) {
      tg.start = this.bas.ui.timeParse(tg.startTime, undefined, tg.start);
    }
    if (!isStart && event?.valueText === undefined) {
      tg.end = this.bas.ui.timeParse(tg.endTime, undefined, tg.end);
    }

    let startTime = this.bas.ui.timeFormat(tg.start);
    let endTime = this.bas.ui.timeFormat(tg.end);


    if (startTime && endTime && endTime <= startTime) {
      tg.end = this.bas.ui.dateAdd(tg.start, { minutes: ti.duration || 30 })
      endTime = this.bas.ui.timeFormat(tg.end);

    }

    // Ensure minimum duration is met when start time changes
    const minDuration = tg.minDurationMinutes || 0;
    if (isStart && minDuration > 0 && startTime) {
      const minEnd = this.bas.ui.dateAdd(tg.start, { minutes: minDuration });
      if (tg.end.getTime() < minEnd.getTime()) {
        tg.end = minEnd;
        endTime = this.bas.ui.timeFormat(tg.end);
      }
    }

    tg.label = startTime + " - " + endTime;
    tg.startTime = startTime;
    tg.endTime = endTime;

    if (pw.startDateAsString && startTime && endTime) {
      const startAsString = pw.startDateAsString + ' ' + startTime;
      let endDateAsString = pw.startDateAsString;
      if (tg.end && tg.start && tg.end.getTime() < tg.start.getTime()) {
        endDateAsString = this.bas.ui.dateToString(this.bas.ui.dateAdd(tg.start, { days: 1 }));
      }
      const endAsString = endDateAsString + ' ' + endTime;

      pw.startAsString = startAsString;
      pw.endAsString = endAsString;
      pw.startAsIso8601 = this.bas.ui.dateToIsoString(this.bas.ui.dateParse(startAsString));
      pw.endAsIso8601 = this.bas.ui.dateToIsoString(this.bas.ui.dateParse(endAsString));
    }


    if (this.bas.ui.r.ltsm && field == 'start' && !event.updateTimeGrid) {
      tg.collapseStart = false;
      tg.collapseEnd = true;
    }


    this.timegridVisibleChange(true);

    let timePeriodAsString = tg.label.replace(/ /g, "");
    if (pw.timePeriodAsString != timePeriodAsString) {

      pw.timePeriodAsString = timePeriodAsString;
      this.change.emit({ field: "timePeriodAsString", value:   pw.timePeriodAsString });
    } else {
      if(this.bas.envtest) console.log("onTimegridChange, timePeriodAsString has not changed: " + timePeriodAsString);
    }
    

// ​event: 
// value: Date Wed May 22 2024 13:00:00 GMT+0200 (Central European Summer Time)
// valueText: "13:00"
  }

  updateTimeGrid(pw:any = this._pw) {
    if (!pw?.productObj?.useTimegrid) return

    const signature = this._getTimegridPwSignature(pw);
    if (this._lastTimegridPwSignature === signature) {
      if(this.bas.envtest) console.log("BtPwPeriodGuestsComponent, updateTimeGrid, signature unchanged, skipping");
      return;
    }
    this._lastTimegridPwSignature = signature;
  
    let tg = this.timegrid;

    let ti = pw.timeItemsAvailable && pw.timeItemsAvailable[0];

    tg.minDurationMinutes = ti?.minDurationMinutes || 0;

    let firstAvailable = ti;

    if (ti) {
      for (let item of ti.items || []) {
        if (item.available > 0) {
          firstAvailable = item;
          break;
        }
      }
  
    }

    let start = this.bas.ui.dateParseIso(pw.startAsIso8601);
    let end = this.bas.ui.dateParseIso(pw.endAsIso8601);
  

    if (firstAvailable) {
      let faStart = this.bas.ui.dateParse(firstAvailable.startAsString);
      let pwStart = this.bas.ui.dateParse(pw.startAsString);

      if(this.bas.envtest) console.log("updateTimeGrid, faStart: " + faStart + "; pwStart: " + pwStart);

      if (pwStart.getTime() < faStart.getTime() ) {
        start = faStart;
        end =  this.bas.ui.dateParse(firstAvailable.endAsString);
      }

    }

    tg.start = start;
    tg.end = end;


    // if (pw.isAvailable) {

    //   tg.start = this.bas.ui.dateParseIso(pw.startAsIso8601);
    //   tg.end =  this.bas.ui.dateParseIso(pw.endAsIso8601);
    // } else {
    //   for (let item of ti.items || []) {
    //     if (item.available > 0) {
    //       tg.start = this.bas.ui.dateParse(item.startAsString);
    //       tg.end =  this.bas.ui.dateParse(item.endAsString);
    //       break;
    //     }
    //   }
    // }

    tg.startTime = this.bas.ui.timeFormat(tg.start);
    tg.endTime = this.bas.ui.timeFormat(tg.end);

    if(this.bas.envtest) console.log("updateTimeGrid, tg.start: "+tg.start+", pw: ",pw,", tg: ", tg);

    this.onTimegridChange('start', { valueText: tg.startTime, updateTimeGrid: true  })
    

  }

  dateOnPageLoading(event:any) {
    // if(this.bas.envtest) console.log("dateOnPageLoading, ", event, ", invalid: ", this.dateInvalid);
    this.dateUpdateInvalid(event);
  }

  onAreaChange(event:any) {
    if(this.bas.envtest) console.log("onAreaChange, startDateAsJsDate: " + this._pw.startDateAsJsDate + ", ev: ", event)

    this._pw.areaId = event;
    this._pw.startDateAsString = "";
    this._pw.timePeriodAsString = "";
    // if (pw.startDateAsString) params.startDateAsString = pw.startDateAsString;
    // if (pw.productObj.tcTime && pw.timePeriodAsString) params.timePeriodAsString = pw.timePeriodAsString;


    this.change.emit({ field: "area", value:  event  });
    
  }

  dateOnChange(event:any) {
    if(this.bas.envtest) console.log("dateOnChange, startDateAsString: " + this._pw.startDateAsString
      + ", startDateAsJsDate: " + this._pw.startDateAsJsDate + ", isRunning: " + this.data.isRunning + ", event: ", event);

      // if (this.data.isRunning) return; 

    let sdThis = this._pw.startDateAsString;



    // this._pw.startDateAsJsDate = event.value;
    // this._pw.startDateAsString = this.bas.ui.dateToString(this._pw.startDateAsJsDate);
    // this._pw.startDateAsString = this.bas.ui.dateToString(event.value);
    this._pw.startDateAsString = this.bas.ui.dateToString(event);
    // this._pw.endDateAsString = this.bas.ui.dateToString(event);

    let sdNext = this._pw.startDateAsString;

    if(this.bas.envtest) console.log("dateOnChange, startDateAsString: " + sdThis + " -> " + sdNext);

    if (sdThis != sdNext ) {
      
      this.change.emit({ field: "startDateAsString", value:  this._pw.startDateAsString  });
    }




  }

  dateRangeOnChange(event:any) {
    if(this.bas.envtest) console.log("dateRangeOnChange, dateRangeOnChange: ", event)
    let dates:Date[] = Array.isArray(event) ? event : event.value;

    if(this.bas.envtest) console.log("dateRangeOnChange, isArray: ", Array.isArray(event))
    // if(this.bas.envtest) console.log("dateRangeOnChange, dateRangeOnChange: ", event)
    // if(this.bas.envtest) console.log("dateRangeOnChange, dateRangeOnChange: ", event)
    // if(this.bas.envtest) console.log("dateRangeOnChange, dateRangeOnChange: ", event)
    
    if (dates === undefined || dates.length != 2 || dates[0] == null || dates[1] == null) return;
    this.pw.periodAsRange =  MiscUtil.datesToDateRange(dates);
    if(this.bas.envtest) console.log("dateRangeOnChange, change.emit: ", this.pw.periodAsRange )
    this.change.emit({ field: "periodAsRange", value:   this.pw.periodAsRange });
  }

  dateRangeOnCalChange(event:any) {
    if(this.bas.envtest) console.log("dateRangeOnCalChange, event: ", event);

  }

  onPeriodChange(event:any) {
    if(this.bas.envtest) console.log("onPeriodChange, event: ", event);
    this.change.emit({ field: "productPeriodAsString", value:   this.pw.productPeriodAsString });

  }

  onTimeChange(event:any) {
    if(this.bas.envtest) console.log("onTimeChange, event: ", event);
    this.change.emit({ field: "timePeriodAsString", value:   this.pw.timePeriodAsString });
  
  }

  

  onChange(event:any, field:string) {
    if(this.bas.envtest) console.log("onChange, event: ", event);


    this.change.emit({ field: field, value:   this.pw[field] });

  }

  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    // differenceInCalendarDays(current, this.today) > 0;

    let today = MiscUtil.getDateAsInt(new Date());
    let dateInt = MiscUtil.getDateAsInt(current);

    if (dateInt < today) return true;

    let pw = this._pw;

    if (pw.selectableDatesNext !== undefined && pw.selectableDatesNext.length) {
      if (MiscUtil.binarySearch(pw.selectableDatesNext, dateInt) < 0) {
        return true;
      }
    // } else if (((pw.selectableDates && pw.selectableDates.length) || pw.productObj.timeProduct)) {
    //   if (MiscUtil.binarySearch(pw.selectableDates, dateInt) < 0) return true;
    } else if (pw.productObj.periodProduct && pw.occupiedDates) {
      if (MiscUtil.binarySearch(pw.occupiedDates, dateInt) >= 0) return true;
    }


    return false

  }

  dateUpdateInvalid(event:any) {
    let inst = event.inst;
    let fd = event.firstDay;
    let ld = event.lastDay;


    let colors:any[] = [];
    let invalid:any[] = [];
    // {
    //   date: fbo.date,
    //   highlight: '#537b53'
    // } 
    
    let pw = this.pw;

    let dates:Date[] = this.bas.ui.getAllDatesBwtweenDates(fd, ld);

    // <c:if test="${wpd.company.username == 'skaperverkettonsberg'}"> <!-- TODO:hack -->
		// 	extraCalendarOptions = { daysOfWeekDisabled: [ 0,6 ]};
		// 	<c:if test="${fn:contains(p.name, 'Revetal')}">
		// 	  extraCalendarOptions = { daysOfWeekDisabled: [ 0 ]};
		// 	</c:if>
		// </c:if>


    let today = MiscUtil.getDateAsInt(new Date());
    let isAdmin = this.bas.aas.isAdminProvider();
    

    
    // let isSkaperverkettonsberg = this.bas.ds.findCid('pw-period-guests.dateUpdateInvalid') === "skaperverkettonsberg";

    for (let current of dates) {
      let dateInt = MiscUtil.getDateAsInt(current);
      if ( dateInt < today) {
        invalid.push(current);
        if (isAdmin && false) colors.push({ date: current, background: 'rgba(237, 28, 36, 0.5)' })
        continue;
      } 

      // if (isSkaperverkettonsberg) { // TODO: hack, dette burde gjøres annerledes
      //   let dow = current.getDay();
      //   if (dow === 0 || (dow === 6 && pw.productObj.mkName.indexOf("Revetal") < 0)) {
      //     invalid.push(current);
      //   }
      // }
   
      
      if (pw.selectableDatesNext  !== undefined && pw.selectableDatesNext.length) {
        if (MiscUtil.binarySearch(pw.selectableDatesNext, dateInt) < 0) {
          //console.log("current: " + current + " -> dateInt: " + dateInt + ", binarySearch: " + MiscUtil.binarySearch(pw.selectableDatesNext, dateInt) + ", pw: ", pw);

          invalid.push(current);

          if (isAdmin) colors.push({ date: current, background: 'rgba(237, 28, 36, 0.5)' })

        }
      // } else if (((pw.selectableDates && pw.selectableDates.length) || pw.productObj.timeProduct)) {
      //   if (MiscUtil.binarySearch(pw.selectableDates, dateInt) < 0) {
      //     invalid.push(current);
      //     if (isAdmin) colors.push({ date: current, background: 'rgba(237, 28, 36, 0.5)' })
      //   }
      } else if (pw.productObj.periodProduct && pw.occupiedDates) {
        if (MiscUtil.binarySearch(pw.occupiedDates, dateInt) >= 0) {
          invalid.push(current);
          if (isAdmin) colors.push({ date: current, background: 'rgba(237, 28, 36, 0.5)' })
        }
      }
    }


    // if (isSkaperverkettonsberg) { // TODO: hack, dette burde gjøres annerledes
    //   invalid.push({
    //     recurring: {
    //       repeat: 'weekly',
    //       weekDays: (pw.productObj.mkName.indexOf("Revetal") < 0 ? 'SA,' : '' )+ 'SU'
    //     }
    //   })
    // }

    //console.log("Setting dateInvalid: " + this.dateInvalid.length + " -> " + invalid.length);
    if (!isAdmin) this.dateInvalid = invalid;
    this.dateColors = colors;



  }

 
  onGuestsUpdate(event:any) {
    if(this.bas.envtest) console.log("onGuestsUpdate, event: ", event);


    let gcs = event.value;
    if (gcs.count === 0) {
      this._pw.quantity = 0;
    } else {
      if (this._pw.productObj.guestsIsCount) {
        this._pw.quantity = gcs.count;
      } else {
        this._pw.quantity = this._pw.quantitySelected || 1
      }
    }
    
    this._pw.guestCounts = gcs;
    
    this.change.emit({ field: "guestCounts", value: event.value });
  }

  onRoomsGuestsUpdate(event:any) {
    if(this.bas.envtest) console.log("onRoomsGuestsUpdate, event: ", event);
    this.change.emit(event); //{ field: "rooms", pw: event.pw, value: event.value });
  }


  onDateRangeChange(idx:number, event:any) {
    if(this.bas.envtest) console.log(MiscUtil.getTimeString() + ", onDateRangeChange, idx: " + idx + ", e: ", event);
   
    let dates = this.pw.periodArray;
    let sd = dates[0];
    let ed = dates[1];
    if (idx == 0) {

      if (ed && ed.getTime() < sd.getTime()) {
        dates[1] = this.bas.ui.dateAdd(sd, { days: 1 })
      }
    }

    this.dateRangeOnChange(dates);

      // (ngModelChange)="dateRangeOnChange($event)"

  }
  pickerDisabledDate = (date:Date):boolean => {

    // console.log("pickerDisabledDate, date: " + date + ", c: ", this.control);
    let today = MiscUtil.getDateAsInt(new Date());
    let dateInt = MiscUtil.getDateAsInt(date);

    if (dateInt < today) return true;

    if (this.opts.admin) return false;

    let pw = this._pw;

    if (pw.selectableDatesNext  !== undefined && pw.selectableDatesNext.length) {
      if (MiscUtil.binarySearch(pw.selectableDatesNext, dateInt) < 0) {
        return true;
      }
    // } else if (((pw.selectableDates && pw.selectableDates.length) || pw.productObj.timeProduct)) {
    //   if (MiscUtil.binarySearch(pw.selectableDates, dateInt) < 0) return true;
    } else if (pw.productObj.periodProduct && pw.occupiedDates) {
      if (MiscUtil.binarySearch(pw.occupiedDates, dateInt) >= 0) return true;
    }

    return false;
  }
  pickerDisabledDateRangeEnd = (date:Date):boolean => {

    if (this.opts.admin) return false;
    
    let disabled = this.pickerDisabledDate(this.bas.ui.dateAdd(date, { days: -1 }));
    if (disabled) return disabled;

    let sd = this.pw.periodArray?.[0];
    if (sd === undefined) return disabled;
    

    if (date.getTime()  < sd.getTime()) {
       if(this.bas.envtest) console.log("pickerDisabledDateRangeEnd, date.getTime()  < sd.getTime(), \n date: " + date + ", \n sd: " + sd );
       return true;
    }
    if (this.pw.selectableDatesNext) {

      let dates:Date[] = this.bas.ui.getAllDatesBwtweenDates(this.bas.ui.dateAdd(sd, { days: 1 }), date);

      for (let current of dates) {
        let prev = this.bas.ui.dateAdd(current, { days: -1 })
        let dateInt = MiscUtil.getDateAsInt(prev);
        
    
        if (MiscUtil.binarySearch(this.pw.selectableDatesNext, dateInt) < 0) {

          if (date.getTime()  > current.getTime()) {
            if(this.bas.envtest) console.log("pickerDisabledDateRangeEnd, \n date: " + date + ", \n current: " + current + ",  \n prev: " + prev + ",  \n dateInt: " + dateInt + ", \n dates: ", dates, ", this.pw.selectableDatesNext: ", this.pw.selectableDatesNext); // + ",  \n pw: ", this.pw);
            return true;
          }
        }
        
      }
    }

    if(this.bas.envtest) console.log("pickerDisabledDateRangeEnd, disabled == false, date: " +  MiscUtil.getDateAsInt(date));
    return false;
  }


}



